import { EBannerType } from '../../constants/bannerType';

type TBannerType = EBannerType.RentNBListing | EBannerType.RentKpnCallback;

export const getBannerType = (bannerType: TBannerType) => {
  switch (bannerType) {
    case EBannerType.RentNBListing:
      return 'new_link';
    case EBannerType.RentKpnCallback:
      return 'new_callback';
  }
};
